export const DELETE_OPERATION = 'DELETE';
export const CREATE_OPERATION = 'CREATE';
export const UPDATE_OPERATION = 'UPDATE';
export const READ_OPERATION = 'READ';
